import { useMemo } from 'react';

import Alert from '@zenbusiness/zui/Alert';
import ClickAwayListener from '@zenbusiness/zui/ClickAwayListener';
import Portal from '@zenbusiness/zui/Portal';
import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';

import { AUTO_HIDE_DURATION_DEFAULT } from '#client/constants/time';

import { SnackbarStyled } from './Toast.styles';

export default function Toast({
  autoHideDuration,
  description,
  handleClose,
  horizontal = 'right',
  offsetBottom,
  open,
  primaryAction = {},
  secondaryAction = {},
  variant = 'alert',
  title,
  vertical = 'top',
  top
}) {
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const anchorOriginDefault = useMemo(
    () => ({
      vertical,
      horizontal: isMobile ? 'center' : horizontal
    }),
    [horizontal, isMobile, vertical]
  );

  const onClickAway = () => {
    handleClose();
  };

  return (
    <Portal>
      <ClickAwayListener onClickAway={onClickAway}>
        <SnackbarStyled
          anchorOrigin={anchorOriginDefault}
          autoHideDuration={autoHideDuration ?? AUTO_HIDE_DURATION_DEFAULT}
          offset={offsetBottom}
          onClose={handleClose}
          open={open}
          top={top}
        >
          <Alert
            slotProps={{
              primaryAction: {
                ...primaryAction
              },
              secondaryAction: {
                ...secondaryAction
              }
            }}
            subtitle={description}
            sx={{ width: 'auto' }}
            title={title}
            variant={variant}
          />
        </SnackbarStyled>
      </ClickAwayListener>
    </Portal>
  );
}

Toast.propTypes = {
  autoHideDuration: PropTypes.number,
  description: PropTypes.string,
  handleClose: PropTypes.func,
  horizontal: PropTypes.string,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  vertical: PropTypes.string,
  primaryAction: PropTypes.shape({}),
  secondaryAction: PropTypes.shape({}),
  offsetBottom: PropTypes.string,
  top: PropTypes.string,
  variant: PropTypes.string
};
